<template>
    <div class="prd-empty has-text-centered">
        <b-icon :icon="icon" size="is-large" />
        <h3 class="title is-6">{{ title }}</h3>
        <p class="has-text-grey">{{ description }}</p>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'PrdEmptyState',
    props: {
        icon: { type: String, default: 'inbox-outline' },
        title: { type: String, default: 'Nenhum registro encontrado' },
        description: { type: String, default: 'Ajuste os filtros ou crie um novo registro.' },
    },
}
</script>

<style scoped>
.prd-empty {
    padding: 3rem 1rem;
    color: #8492a6;
}
.prd-empty .title {
    margin: 0.75rem 0 0.25rem;
    color: #52606d;
}
</style>
